import InfoCardSection from './info-card-section-container';


export default InfoCardSection;